<template>
    <div class="login-page">
        <loading :active="loginStatus == 'PENDING'" loader="dots" :is-full-page="true" color="#2E9E4F"></loading>

        <!-- Panel izquierdo: hero (65%) -->
        <div class="login-hero">
            <div class="login-hero-bg"></div>
            <div class="login-hero-overlay"></div>

            <div class="login-hero-content">
                <img src="@/assets/images/logo_cleverdocs_blanc.png" class="hero-logo" width="180" alt="CleverDocs">

                <h1 class="hero-title">{{ $t('login_hero_title') }}</h1>
                <p class="hero-subtitle">{{ $t('login_hero_subtitle') }}</p>
            </div>

            <span class="hero-rights">&copy; CleverBusiness Solutions, SL &mdash; {{ $t('login_all_rights') }}</span>
        </div>

        <!-- Panel derecho: formulario (25%) -->
        <div class="login-panel">
            <div class="login-form-wrapper">
                <div v-if="!reset_password">
                    <div class="login-form-header">
                        <img src="@/assets/images/logo_cleverdocs.png" width="180" alt="CleverDocs">
                        <h2 class="login-welcome">{{ $t('login_welcome') }}</h2>
                        <p class="login-welcome-subtitle">{{ $t('login_welcome_subtitle') }}</p>
                    </div>

                    <form v-on:submit.prevent="onPressLogin">
                        <div class="form-group">
                            <label>{{ $t("Usuario") }}</label>
                            <input type="email" v-model="login.email" autocomplete="false" :placeholder="$t('Usuario')" class="form-control">
                            <div v-if="$v.login.email.$error" class="invalid-feedback">
                                <div v-if="!$v.login.email.required">{{ $t('Campo_requerido') }}</div>
                                <div v-if="!$v.login.email.emal">{{ $t('validation_email') }}</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>{{ $t("Password") }}</label>
                            <input type="password" v-model="login.password" autocomplete="false" :placeholder="$t('Password')" class="form-control">
                            <div v-if="$v.login.password.$error" class="invalid-feedback">
                                <span v-if="!$v.login.password.required">{{ $t('Campo_requerido') }}</span>
                            </div>
                        </div>
                        <div v-if="loginStatus == 'ERROR'" class="invalid-feedback">
                            <span>{{ $t('error_login') }}</span>
                        </div>

                        <button type="submit" @click="onPressLogin()" class="btn-login">{{ $t("Login") }}</button>

                        <div class="text-center login-recovery-link" @click="reset_password = true">
                            <span>{{ $t("recoveryPassword") }}</span>
                        </div>
                    </form>
                </div>
                <div v-else>
                    <div class="login-form-header">
                        <img src="@/assets/images/logo_cleverdocs.png" width="180" alt="CleverDocs">
                        <h2 class="login-welcome">{{ $t('RecoveryPassword') }}</h2>
                    </div>

                    <div class="form-group">
                        <label class="text-left w-100 recovery-text">{{ $t("recoveryText") }}</label>
                    </div>
                    <div class="form-group">
                        <label>{{ $t("Email") }}</label>
                        <input type="email" v-model="recovery.email" autocomplete="false" :placeholder="$t('Email')" class="form-control">
                        <div v-if="$v.recovery.email.$error" class="invalid-feedback">
                            <div v-if="!$v.recovery.email.required">{{ $t('Campo_requerido') }}</div>
                            <div v-if="!$v.recovery.email.emal">{{ $t('validation_email') }}</div>
                        </div>
                    </div>

                    <button type="submit" @click="onResetPassword()" class="btn-login">{{ $t("Enviar") }}</button>

                    <div class="text-center login-recovery-link" @click="reset_password = false">
                        <span>{{ $t("Volver") }}</span>
                    </div>
                </div>

                <span class="panel-rights">&copy; CleverBusiness Solutions, SL<br>{{ $t('login_all_rights') }}</span>
            </div>
        </div>
    </div>
</template>
<script>
    import { required, email} from 'vuelidate/lib/validators';
    import { mapGetters } from 'vuex';
    import Loading from 'vue-loading-overlay';

    export default {
        data() {
            return {
                login : {
                    email   : null,
                    password: null,
                },
                error: null,
                recovery : {
                                        email   : null,

                },
                reset_password : false,
            }
        },
        validations(){
            return {
                login : {
                    email : {
                        required,
                        email
                    },
                    password : {
                        required
                    },
                },
                recovery : {
                      email : {
                        required,
                        email
                    },
                }
            }
        },
        beforeMount() {
          this.getPathUrl()
        },
        computed: {
            ...mapGetters({
                loginStatus: 'login/loginStatus',
            })
        },
        components : {
            Loading
        },
        methods : {
            getPathUrl: function() {
            },
            onPressLogin(){
                this.$v.login.$touch();
                if(!this.$v.login.$invalid){
                     this.$store.dispatch("login/login", {
                        email: this.login.email,
                        password: this.login.password
                    })
                }
            },
            onResetPassword(){
                this.$v.recovery.$touch();
                let self = this;
                if(!this.$v.recovery.$invalid){
                    this.$store.dispatch('isLoadingOn');
                    this.$axios.post("auth/recovery_password",{ email : this.recovery.email})
                    .then(() =>{
                        self.reset_password = false;
                        self.recovery.email = null;
                        this.$store.dispatch('isLoadingOff');
                        self.$dialog.alert({
                            title: self.$t("RecoveryPassword"),
                            body: self.$t("RecoveryPasswordText")
                        });
                        self.$v.recovery.$reset();
                    })
                    .catch(() => {
                        this.$store.dispatch('isLoadingOff');
                        self.$dialog.alert({
                            title: self.$t("RecoveryPassword"),
                            body: self.$t("server_error")
                        }, { customClass: 'cd-dialog cd-dialog--danger' })
                    })
                }
            }
        },
    }
</script>
<style scoped>
.login-page {
    display: flex;
    min-height: 100vh;
    width: 100%;
}

/* ---------- Panel izquierdo (hero) ---------- */
.login-hero {
    position: relative;
    flex: 0 0 65%;
    max-width: 65%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 6vh 8vw;
    overflow: hidden;
    background: #0f5c2e;
    color: #fff;
}

.login-hero-bg {
    position: absolute;
    inset: 0;
    background-image: url('/images/background_login.png');
    background-size: cover;
    background-position: center;
    z-index: 0;
}

.login-hero-overlay {
    position: absolute;
    inset: 0;
    z-index: 1;
    background: linear-gradient(90deg, rgba(4, 26, 13, 0.92) 0%, rgba(5, 34, 17, 0.75) 28%, rgba(5, 34, 17, 0.3) 55%, rgba(5, 34, 17, 0.05) 80%);
    pointer-events: none;
}

.login-hero-content {
    position: relative;
    z-index: 2;
    max-width: 620px;
}

.hero-logo {
    height: auto;
    margin-bottom: 0.5vh;
    filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.45));
}

.hero-title {
    font-size: 2.6rem;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 1.2rem;
    text-shadow: 0 2px 12px rgba(0, 0, 0, 0.45);
}

.hero-subtitle {
    font-size: 1.1rem;
    font-weight: 500;
    opacity: 0.97;
    margin-bottom: 3rem;
    max-width: 520px;
    text-shadow: 0 1px 10px rgba(0, 0, 0, 0.55);
}

.hero-rights {
    position: relative;
    z-index: 2;
    margin-top: auto;
    padding-top: 4vh;
    font-size: 0.78rem;
    opacity: 0.8;
    text-shadow: 0 1px 6px rgba(0, 0, 0, 0.4);
}

/* ---------- Panel derecho (formulario) ---------- */
.login-panel {
    flex: 0 0 35%;
    max-width: 35%;
    min-width: 340px;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    padding: 4vh 2.5vw;
}

.login-form-wrapper {
    width: 100%;
    max-width: 340px;
}

.login-form-header {
    text-align: center;
    margin-bottom: 2.2rem;
}
.login-form-header img {
    margin-bottom: 0.1rem;
}

.login-welcome {
    font-size: 1.4rem;
    font-weight: 600;
    color: #2a2f3c;
    margin-bottom: 0.35rem;
}
.login-welcome-subtitle {
    font-size: 0.9rem;
    color: #8a8f9c;
    margin-bottom: 0;
}

.recovery-text {
    font-size: 0.88rem;
    color: #6b7280;
}

.login-panel .form-group label {
    font-size: 0.82rem;
    font-weight: 600;
    color: #4a4f5c;
}
.login-panel .form-control {
    border-radius: 10px;
    border: 1px solid #e2e5ec;
    padding: 0.65rem 0.9rem;
    height: auto;
}
.login-panel .form-control:focus {
    border-color: #2E9E4F;
    box-shadow: 0 0 0 3px rgba(46, 158, 79, 0.14);
}

.btn-login {
    width: 100%;
    border: none;
    border-radius: 10px;
    padding: 0.75rem 1rem;
    margin-top: 0.5rem;
    background: #2E9E4F;
    color: #fff;
    font-weight: 600;
    font-size: 0.95rem;
    transition: background 0.15s ease;
}
.btn-login:hover {
    background: #24803f;
}

.login-recovery-link {
    margin-top: 1.2rem;
    font-size: 0.85rem;
    color: #2E9E4F;
    cursor: pointer;
}
.login-recovery-link:hover {
    text-decoration: underline;
}

.invalid-feedback {
    display: block;
}

.panel-rights {
    display: none;
    text-align: center;
    margin-top: 2.5rem;
    font-size: 0.75rem;
    color: #6b7280;
}

/* ---------- Responsive ---------- */
@media (max-width: 991.98px) {
    .login-hero {
        display: none;
    }
    .login-panel {
        flex: 1;
        max-width: 100%;
        min-width: 0;
        min-height: 100vh;
    }
    .panel-rights {
        display: block;
    }
}

@media (max-width: 575.98px) {
    .login-panel {
        padding: 4vh 6vw;
    }
}
</style>
